export const androidSaveUser = userObjectJson => {
    try {
        // eslint-disable-next-line no-undef
        if (PolyKidsAndroid) {
            // eslint-disable-next-line no-undef
            PolyKidsAndroid.saveUser(userObjectJson);
        }
        // eslint-disable-next-line no-empty
    } catch (error) {

    }
}

export const androidDestroyUser = () => {
    try {
        // eslint-disable-next-line no-undef
        if (PolyKidsAndroid) {
            // eslint-disable-next-line no-undef
            PolyKidsAndroid.destroyUser();
        }
        // eslint-disable-next-line no-empty
    } catch (error) {

    }
}

export const isAndroid = () => {
    try {
        // eslint-disable-next-line no-undef
        if (PolyKidsAndroid) {
            return true
        }
        return false
    } catch (error) {
        return false
    }
}

export const androidRouterBeforeEach = (fromPath, toPath) => {
    try {
        // eslint-disable-next-line no-undef
        if (PolyKidsAndroid) {
            // eslint-disable-next-line no-undef
            PolyKidsAndroid.routerBeforeEach(fromPath, toPath);
        }
        // eslint-disable-next-line no-empty
    } catch (error) {

    }
}

export const androidOrderCourse = (courseId) => {
    try {
        // eslint-disable-next-line no-undef
        if (PolyKidsAndroid) {
            // eslint-disable-next-line no-undef
            PolyKidsAndroid.orderCourse(courseId);
        }
        // eslint-disable-next-line no-empty
    } catch (error) {

    }
}
